export default "__VITE_ASSET__BBoFaaHD__"